import axios from '@/axios'

const multiagent = {
  // customer
  async getUserList(params) {
    return await axios.post('/uc/agent/getSubordinateUserList', params, {
      des: '直客pc获取名下用户列表',
      sTime: new Date().getTime(),
    })
  },
  // 导出机构客户
  async exportUserList(params) {
    return await axios.post('/uc/agent/exportSubordinateUserList', params, {
      des: '直客pc导出名下用户列表',
      sTime: new Date().getTime(),
    })
  },
  // 机构客户持仓
  async getPositionDetail(params) {
    return await axios.post('/uc/agent/positionDetail', params, {
      des: '直客pc获取机构客户持仓',
      sTime: new Date().getTime(),
    })
  },
  // 机构客户平仓
  async getCloseOrderDetail(params) {
    return await axios.post('/uc/agent/closeOrderDetail', params, {
      des: '直客pc获取机构客户平仓',
      sTime: new Date().getTime(),
    })
  },
  // 下级用户返佣明细
  async getTradeInfoDetails(params) {
    return await axios.post('/uc/agent/tradeInfoDetails', params, {
      des: '直客pc获取下级用户返佣明细',
      sTime: new Date().getTime(),
    })
  },
  // 导出下级用户返佣明细
  async exportTradeInfoDetails(params) {
    return await axios.post('/uc/agent/exportTradeInfoDetails', params, {
      des: '直客pc导出下级用户返佣明细',
      sTime: new Date().getTime(),
    })
  },
  // 导出下级用户返佣明细
  async getBankrollInfo(params) {
    return await axios.post('/uc/agent/bankrollInfo', params, {
      des: '直客pc获取资金信息',
      sTime: new Date().getTime(),
    })
  },
  // 电子钱包
  async getElectronicWallet(params) {
    return await axios.post('/uc/commissionManage/electronicWallet', params, {
      des: '直客pc电子钱包',
      sTime: new Date().getTime(),
    })
  },
  // 电子钱包获取银行列表
  async getBankList(params) {
    return await axios.post('/uc/user/bank/list', params, {
      des: '直客pc获取电子钱包获取银行列表',
      sTime: new Date().getTime(),
    })
  },
  // 提取佣金
  async extractCommission(params) {
    return await axios.post('/uc/commissionManage/extractCommission', params, {
      des: '直客pc提取佣金',
      sTime: new Date().getTime(),
    })
  },
  // 佣金记录
  async getCommissionManageList(params) {
    return await axios.post('/uc/commissionManage/list', params, {
      des: '直客pc获取佣金记录',
      sTime: new Date().getTime(),
    })
  },
  // 佣金明细
  async getCMTradeInfoDetails(params) {
    return await axios.post('/uc/commissionManage/tradeInfoDetails', params, {
      des: '直客pc获取佣金明细',
      sTime: new Date().getTime(),
    })
  },
  // 返点标准
  async getGroupsAndBackPoint(params) {
    return await axios.post('/uc/agent/getGroupsAndBackPoint', params, {
      des: '直客pc获取返点标准',
      sTime: new Date().getTime(),
    })
  },
  // 导出返佣明细
  async exportTradeDetails(params) {
    return await axios.post('/uc/commissionManage/exportTradeInfoDetails', params, { des: '直客pc导出返佣明细', sTime: new Date().getTime() })
  },
  // 获取名下客户持仓报表
  async getUserPositionsCount(params) {
    return await axios.get('/uc/agent/reports/userPositionsCount', params, {
      des: '直客pc获取名下客户持仓报表',
      sTime: new Date().getTime(),
    })
  },
  // 导出名下客户持仓报表
  async exportUserPositionsCount(params) {
    return await axios.get('/uc/agent/reports/exportUserPositionsCount', params, { des: '直客pc导出名下客户持仓报表', sTime: new Date().getTime() })
  },
  // 获取名下客户平仓报表
  async getUserClosePositionsCount(params) {
    return await axios.get('/uc/agent/reports/userClosePositionsCount', params, { des: '直客pc获取名下客户平仓报表', sTime: new Date().getTime() })
  },
  // 导出名下客户平仓报表
  async exporttUserClosePositionsCount(params) {
    return await axios.get('/uc/agent/reports/exprotUserClosePositionsCount', params, { des: '直客p出名下客户平仓报表', sTime: new Date().getTime() })
  },
  // 获取名下客户资金报表
  async getBankrollCount(params) {
    return await axios.post('/uc/agent/reports/bankrollCount', params, {
      des: '直客pc获取名下客户资金报表',
      sTime: new Date().getTime(),
    })
  },
  // 导出名下客户资金报表
  async exportBankrollCount(params) {
    return await axios.post('/uc/agent/reports/exportBankrollCount', params, {
      des: '直客pc导出名下客户资金报表',
      sTime: new Date().getTime(),
    })
  },
  // 获取盈亏报表
  async getTradeCount(params) {
    return await axios.post('/uc/agent/reports/tradeCount', params, {
      des: '直客pc获取盈亏报表',
      sTime: new Date().getTime(),
    })
  },
  // 导出名下客户盈亏报表
  async exportTradeCount(params) {
    return await axios.post('/uc/agent/reports/exportTradeCount', params, {
      des: '直客pc导出名下客户盈亏报表',
      sTime: new Date().getTime(),
    })
  },
  //升级代理/修改返佣
  async AgentDetails(params) {
    return await axios.post('/uc/agent/agentUpdateInfo', params, {
      des: '直客pc升级代理/修改返佣',
      sTime: new Date().getTime(),
    })
  },
  // 修改下级返佣
  async modifyAgent(params) {
    return await axios.post('/uc/agent/agentUpdate', params, {
      des: '直客pc修改下级返佣',
      sTime: new Date().getTime(),
    })
  },
  // 邀请码
  async getPromotionNumber(params) {
    return await axios.post('/uc/user/userinfo/getPromotionNumber', params, {
      des: '直客pc邀请码',
      sTime: new Date().getTime(),
    })
  },
  // 名下客户数据统计
  async getDailiSubordinateUserData(params) {
    return await axios.post('/uc/agent/getDailiSubordinateUserData', params, {
      des: '直客pc名下客户数据统计',
      sTime: new Date().getTime(),
    })
  },
  // 名下各客户数据统计
  async getSubordinateUserData(params) {
    return await axios.post('/uc/agent/getSubordinateUserData', params, {
      des: '直客pc名下各客户数据统计',
      sTime: new Date().getTime(),
    })
  },
  // 名下各客户数据统计-导出
  async exportSubordinateUserData(params) {
    return await axios.post('/uc/agent/exportSubordinateUserData', params, {
      des: '直客pc名下各客户数据统计-导出',
      sTime: new Date().getTime(),
    })
  },
  // 获取合约细则文件
  async getContractInfo(params) {
    return await axios.get('/common/getContractInfo', params, {
      des: '获取合约细则文件',
      sTime: new Date().getTime(),
    })
  },

  //基础认证
  async foundationIdentityInfoSubmit(params) {
    return await axios.post('/uc/user/userinfo/foundationIdentityInfoSubmit', params, { des: '基础认证', sTime: new Date().getTime() })
  },
}

export default multiagent



// WEBPACK FOOTER //
// ./src/api/multiagent.js